import { FluidMetricsPage } from "./fluidMetrics";

export const FluidMetrics = FluidMetricsPage;
